import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyHubDocumentMetadata } from "@/lib/applyHubDocumentMetadata";
import { useHubModuleKey } from "@/lib/hubModuleKeyContext";
import { useNavigationTrail } from "@/lib/navigationTrailContext";

/** Keeps browser tab title and favicon in sync with hub navigation. */
export function HubDocumentMetadataSync(): null {
  const { pathname } = useLocation();
  const { currentLabel } = useNavigationTrail();
  const moduleKeyFromLayout = useHubModuleKey();

  useLayoutEffect(() => {
    applyHubDocumentMetadata({
      pathname,
      registeredPageLabel: currentLabel,
      moduleKey: moduleKeyFromLayout,
    });
  }, [pathname, currentLabel, moduleKeyFromLayout]);

  return null;
}
